import type {
  DailyNote,
  DailyNotePayload,
  DailyNotesData,
  DailyNotesParams,
} from '@/libs/interfaces'

import { mockDailyNotes } from '../fixtures/dailyNotes'
import { delay, genID, nowISO } from '../helpers'
import { createEntityStore } from '../store'

const dailyNoteStore = createEntityStore<DailyNote, 'storeDailyNoteID'>(
  mockDailyNotes,
  'storeDailyNoteID',
)

const filterDailyNotes = (params: DailyNotesParams): DailyNote[] =>
  dailyNoteStore
    .find((note) => note.storeID === params.storeID)
    .filter((note) => (params.from ? note.date >= params.from : true))
    .filter((note) => (params.to ? note.date <= params.to : true))

export const dailyNotesApiMock = {
  getDailyNotes: async (params: DailyNotesParams): Promise<DailyNote[]> =>
    delay(filterDailyNotes(params)),

  createOrUpdateDailyNotes: async (
    payload: DailyNotePayload,
  ): Promise<DailyNotesData | undefined> => {
    const savedNotes = payload.dailyNotes.map((input) => {
      const existing = dailyNoteStore
        .find((note) => note.storeID === payload.storeID && note.date === input.date)
        .at(0)

      if (existing) {
        return (
          dailyNoteStore.update(existing.storeDailyNoteID, {
            note: input.note,
            updatedAt: nowISO(),
          }) ?? existing
        )
      }

      const created: DailyNote = {
        storeDailyNoteID: genID('daily-note'),
        storeID: payload.storeID,
        date: input.date,
        note: input.note,
        createdAt: nowISO(),
        updatedAt: nowISO(),
      }
      dailyNoteStore.insert(created)
      return created
    })

    return delay({
      dailyNotes: savedNotes,
    })
  },
}
